/* eslint-disable no-use-before-define */
import React from 'react'
import { default as useOfferings, toParams } from './use-offerings'
import Criteria from './criteria'
import Grid from './grid'
import ViewMore from './view-more'
import { show, fmt, arrayFrom, arrayUnique, trackPage } from '../twd'
import { saveSearch } from '../advanced-screener/search-form/save-search-button'
import Selection from './selection'

export default ({searchParams, _ts, from, backFrom}) => {
    trackPage('search-results')

    const {
        Last, params, status,
        rows, invType, count, selection,
        onSelect, clearSelection,
        onLoadMore,

    } = useOfferings({searchParams, _ts, from, backFrom})

    const invTypeTitle = {
        'C': 'Corporate bonds',
        'M': 'Municipal bonds',
        'S': 'CDs',
        'T': 'U.S. Treasuries',
        'A': 'Agency bonds',
    }[invType] || ''

    const sortType = arrayFrom((params || {}).sort)[0]

    const hasHighYield = arrayFrom(rows).find(r => r.highYieldInd==='Y')
    const hasStructuredProduct = arrayFrom(rows).find(r => r.holdSpInd==='Y')
    const isBondLookup = invType ==='-'

    return <React.Fragment>
        <div className="container">
        <div className="row vertical-offset-xs">
        <div className="col-md-12 col-xs-12">
            <h3 style={{display:'inline'}}>
                { invTypeTitle || 'Bonds' }
            </h3>
            &nbsp;&nbsp;
            {fmt.count(count)} results
            &nbsp;&nbsp;
            {!isBondLookup && <a href='#'
                data-name="offerings-edit-search-criteria"
                style={{cursor:'pointer'}}
                onClick={() => {
                let sp = toParams(Last.value.params, 1)
                if (invType==='M' && !sp.holdCusip && !sp.holdState) {
                    sp.holdState = []
                }
                if (invType==='S' && !sp.holdCusip && !sp.holdBlueSkyStateCD) {
                    sp.holdBlueSkyStateCD = []
                }
                sp.isEdit = true

                if (!('holdInvType' in sp)) {
                    let cs = Last.value.searchCriteria || []
                    let ts = cs
                        .filter(c => c.code.indexOf('holdInvType')===0)
                        .map(c => c.code.split('-')[1])
                        .filter(Boolean)
                    if (ts.length===1) sp.holdInvType = ts[0]
                }

                if (!('holdInvType' in sp)) {
                    let ts = arrayUnique(arrayFrom(rows).map(r => r.holdInvType))
                    if (ts.length===1) sp.holdInvType = ts[0]
                }

                show('advanced-screener', {
                    searchParams: sp,
                    _ts: Date.now(),
                    from: Last.value.from
                })
                }}
            >Edit search criteria</a>}

            &nbsp; &nbsp;
            <a href='#'
                data-name="offerings-save-this-search"
                style={{cursor:'pointer'}}
                onClick={async () => {
                    await saveSearch({values: Last.value.params})
                }}
            >Save this search</a>
        </div>
        </div>
        </div>


        <div className="container" style={{background:"#ffffff"}}>
        <div className={hasHighYield ? "row vertical-offset-xs" : "row vertical-offset-base"}>
        <div className="col-xs-12">
            <Criteria Last={Last} />
        </div>
        </div>

        { hasHighYield &&
            <div className="row" >
            <div className="col-xs-12">
                <div className="universal-message universal-message-info" role="status">
                <div className="universal-message-content">
                <div className="universal-message-heading">High yield bonds are riskier than investment grade bonds.</div>
                </div>
                </div>
            </div>
            </div>
        }
        { hasStructuredProduct &&
            <div className="row" >
            <div className="col-xs-12">
                <div className="universal-message universal-message-info" role="status">
                <div className="universal-message-content">
                <div className="universal-message-heading">Search results include Structured Products, which have unique risks.</div>
                </div>
                </div>
            </div>
            </div>
        }

        <div className="row vertical-offset-sm">
        <div className="col-xs-12">
            <Grid
                Last={Last}
                invType={invType}
                rows={rows} sort={sortType}
                status={status}
                selection={selection}
                onSelect={onSelect} />
            <ViewMore
                pageSize={params.resultsPerPage || 10}
                rows={rows}
                status={status}
                count={count}
                onLoadMore={onLoadMore} />
        </div>
        </div>

        <div className="row vertical-offset-lg">&nbsp;</div>

        <Selection
            invType={invType}
            selection={selection}
            clearSelection={clearSelection} />

        </div>
        </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/offerings/offerings.js